module.exports = __webpack_public_path__ + "static/media/dekton.b3ac5809.svg";